import React, { useEffect, useState } from 'react';
import './LoadingPage.css';


const LoadingPage = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.mjs";
        script.type = "module";
        document.body.appendChild(script);
    
        return () => {
          document.body.removeChild(script); // Clean up the script when component unmounts
        };
    }, []);

    return (
        <div className="loading-page-width">
            <dotlottie-player 
                src="https://lottie.host/e699377e-74d5-46c7-9b4d-38b547c13313/IV5NUWLpZu.json"
                background="transparent"
                speed="1"
                style={{ width: '100px', height: '100px' }}
                loop
                autoplay
            ></dotlottie-player>
            <img src='/loadingPageLayer.png' alt='loadingPage'/>
        </div>
    )
}

export default LoadingPage;